"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Table_1 = __importDefault(require("./Table"));
function AdvancedTable(props) {
    const tableComponent = (0, react_1.useRef)(null);
    const [data, setData] = (0, react_1.useState)(props.data);
    const [sort, setSort] = (0, react_1.useState)(props.sort || { direction: 'asc' });
    (0, react_1.useEffect)(() => {
        // this check is here to make sure the child Table component exists
        // this condition is hard to re-create in Jest, so we ignore it for coverage
        /* istanbul ignore else */
        if (tableComponent.current) {
            // table type has changed, reset the scroll and regenerate the cells
            tableComponent.current.reloadTable();
        }
    }, [props.tableInstance]);
    (0, react_1.useEffect)(() => {
        // data prop has changed, update the data state to match it
        setData(props.data);
    }, [props.data]);
    (0, react_1.useEffect)(() => {
        // sort prop has changed, update the sort state to match it
        setSort(props.sort || { direction: 'asc' });
    }, [props.sort]);
    (0, react_1.useEffect)(() => {
        // table data has changed, reset the scroll and regenerate the cells
        if (tableComponent.current) {
            tableComponent.current.reloadTable();
        }
    }, [data]);
    function sortColumn(field, direction) {
        if (props.localSort) {
            const column = props.columns.data[field];
            const comparatorMultiplier = direction === 'asc' ? 1 : -1;
            const sortedData = data
                ? [...data].sort((a, b) => {
                    const aSortValue = column.sortValue
                        ? column.sortValue(a)
                        : a[field];
                    const bSortValue = column.sortValue
                        ? column.sortValue(b)
                        : b[field];
                    if (aSortValue > bSortValue) {
                        return 1 * comparatorMultiplier;
                    }
                    if (aSortValue < bSortValue) {
                        return -1 * comparatorMultiplier;
                    }
                    return 0;
                })
                : [];
            setData(sortedData);
            setSort({ direction, field });
        }
        props.loadNextPage({ direction, field });
        if (tableComponent.current) {
            tableComponent.current.reloadTable();
        }
    }
    function prepareTable() {
        let x = 0;
        for (const key of props.columns.visibleOrder) {
            const column = props.columns.data[key];
            column.x = x;
            x += column.width;
        }
        let totalWidth = 0;
        const columnOrder = props.columns.visibleOrder;
        const columns = columnOrder.map((columnTitle) => {
            const column = props.columns.data[columnTitle];
            const columnX = totalWidth;
            totalWidth += column.width;
            return {
                x: columnX,
                width: column.width
            };
        });
        return {
            columns,
            width: totalWidth
        };
    }
    /* render */
    const calculatedValues = prepareTable();
    return ((0, jsx_runtime_1.jsx)("div", { className: "bah-uswds-advanced-table", children: (0, jsx_runtime_1.jsx)(Table_1.default, { rowCount: data ? data.length : 0, rowHeight: 40, headerHeight: 50, contentWidth: calculatedValues.width, bodyWidth: props.visibleWidth, bodyHeight: props.visibleHeight, data: data, columns: props.columns, columnCoords: calculatedValues.columns, currentSort: sort, sortFn: sortColumn, onReachedBottom: props.loadNextPage, ref: (table) => {
                tableComponent.current = table;
            }, borderless: props.borderless }) }));
}
exports.default = AdvancedTable;
AdvancedTable.defaultProps = {
    borderless: false,
    localSort: true,
    sort: {
        direction: 'asc',
        field: ''
    }
};
